import {Button, List, Space, Table, Tag} from "antd";
import {FinanceEntryTypeComponent} from "../../finance-entry/component/finance-entry.type.component";
import {SettingOutlined} from "@ant-design/icons";
import {useEffect, useState} from "react";
import {FinanceEntryEntity} from "../../../../../domain/entity/finance-entry.entity";
import {useFinanceEntryRepository} from "../../../../../domain/repository/finance-entry.repository";
import moment from "moment";
import {ShowFinanceEntryModal} from "../../finance-entry/component/show-finance-entry/modal";
import {ColumnsType} from "antd/es/table";

export function FinanceEntriesComponent() {
  const formatter = new Intl.NumberFormat('pt-BR', {
    style: 'currency', currency: 'BRL'
  })
  const [entries, setEntries]  = useState<FinanceEntryEntity[]>([])
  const [showEntry, setShowEntry] = useState<FinanceEntryEntity>();
  const entryRepo = useFinanceEntryRepository();
  const loadEntries = () => entryRepo.loadPendingEntries().then(res => setEntries(res.data));
  
  useEffect(() => {
    loadEntries()
  }, []);
  
  
  function renderTime(item: FinanceEntryEntity) {
    if (!item.dueDate) return null;
    const now = new Date().toISOString().substring(0, 10)
    const diff = moment(item.dueDate.substring(0, 10)).diff(now,'day');
    if (diff < 0) {
      return <Tag color={'red'}>Venceu a {Math.abs(diff)} dias</Tag>
    }
    if (diff === 0) {
      return <Tag color={'red'}>Vence hoje</Tag>
    }
    if (diff > 0 && diff <= 4) {
      return <Tag color={'warning'}>Vence em {diff} dia(s)</Tag>
    }
    return <Tag color={'cyan'}>Vence em {diff} dias</Tag>
  }
  
  function renderTitle(item: FinanceEntryEntity) {
    return (
      <Space>
        {formatter.format(item.amount)}
        <FinanceEntryTypeComponent type={item.type} />
        {renderTime(item)}
      </Space>
    )
  }
  
  const Title = () => <h3>Lançamentos Pendentes</h3>
  
  return (
    <>
      <Table
        columns={[
          {
            title: 'Tipo',
            dataIndex: 'type',
            render: type => <FinanceEntryTypeComponent type={type} />
          },
          {
            title: 'Valor',
            dataIndex: 'amount',
            render: formatter.format,
          },
          {
            title: 'Vencimento',
            dataIndex: 'dueDate',
            render: (_, item) => renderTime(item)
          },
          {
            title: 'Cliente / Fornecedor',
            dataIndex: 'supplier',
            render: (sup, row) => sup?.name ? sup.name : row.client?.name,
          },
          {
            title: '',
            dataIndex: 'id',
            render: (id, item) => <Button onClick={() => setShowEntry(item)} icon={<SettingOutlined/>} size={'small'} />
          }
        ] as ColumnsType<FinanceEntryEntity>}
        dataSource={entries}
      />
      
      {
        showEntry && (
          <ShowFinanceEntryModal
            financeEntryCode={showEntry?.id ?? ""}
            onClose={() => setShowEntry(undefined)}
            entry={showEntry}
            open
            enableAction
            onUpdated={() => {
              setShowEntry(undefined)
              loadEntries()
            }}
          />
        )
      }
    </>
  )
  
}